export const fbInstaConsent = `
<div>
  Wenn Sie X, Facebook, Instagram, YouTube, LinkedIn oder die dazugehörigen Dienste nutzen, werden <a href="#warn_yellowFbInsta">Ihre personenbezogene Daten</a> sowie Ihr Nutzerverhalten und Lesedaten von den Betreibern dieser Plattformen zur <a href="#warn_greenFbInsta">Profilbildung</a> (u.a. Personalisierung für eigene Produkte und Werbung Dritter) gesammelt. Ihre Daten werden mit Ihren Netzwerkkontakten, aber auch mit Dritten <a href="#warn_blueFbInsta">geteilt</a>. Sie werden außerdem in die USA, die kein gleichwertiges Schutzniveau Ihrer Daten zu Deutschland bieten, <a href="#warn_darkFbInsta">übermittelt</a> und dort für geschäftliche Zwecke (z. B. personalisierte Werbung) wie beschrieben gespeichert, verarbeitet und an Dritte weitergegeben. Die öffentlichen Stellen (also Gemeinden, Behörden, Gerichte, Regierungsstellen, etc.), die einen X-, YouTube-,Facebook- oder Instagram-Auftritt haben, sind für die hier beschriebene Datensammlung insofern mitverantwortlich, als dass sie den genannten Netzwerken die Datensammlung erst ermöglichen, u.a. durch das Setzen von Cookies.
</div>

<h1 class="warn_h1" id="warn_yellowFbInsta">Welche personenbezogene Daten sammelt Facebook (& Instagram)?</h1>

<h2 class="warn_h2">Facebook & Instagram sammeln verschiedene personenbezogene Daten, die Sie und andere mitteilen. Dazu gehören folgende Daten:</h2>

<dl class="warn_section_list">
  <dt class="warn_section_item">Informationen & Inhalte, die Sie mitteilen</dt>
  <dd class="warn_section_desc">Metadaten, Texte, Bilder, Videos, Beziehungsstatus, Bildungsweg, Arbeitgeber, Kamera, Standortmitteilen</dd>

  <dd class="warn_section_desc">Daten unter besonderem Schutz: Religion, Sexuelle Orientierung, Politische Orientierung etc.</dd>
  <dt class="warn_section_item">Netzwerke und Verbindungen</dt>
  <dd class="warn_section_desc">Seiten, Gruppen, Profile, Hashtags, Accounts</dd>

  <dt class="warn_section_item">Ihre Nutzung</dt>
  <dd class="warn_section_desc">Features, Interaktionen, Kamera</dd>

  <dt class="warn_section_item">Informationen über Transaktionen mit den Facebook-Produkten</dt>
  <dd class="warn_section_desc">Seiten, Gruppen, Profile, Hashtags, Accounts</dd>

  <dt class="warn_section_item">Netzwerke und Verbindungen</dt>
  <dd class="warn_section_desc">Zahlungsmethoden & Informationen, Kredit- oder Bankkartennummer</dd>

  <dt class="warn_section_item">Dinge, die andere tun, und Informationen, die andere über Sie bereitstellen</dt>
  <dd>Fotos, Kommentare, Nachrichten, Kontaktinfo, Beziehung</dd>
</dl>

<h2 class="warn_h2">Geräte-Informationen</h2>

<dl class="warn_section_list">
  <dt class="warn_section_item">Geräte-Informationen</dt>
  <dd class="warn_section_desc">Computer, Telefone, angeschlossene Fernseher und andere mit dem Internet verbundene Geräte</dd>
  <dd class="warn_section_desc">Betriebssystem, Hardware- und Software-Versionen, Akkustand, Signalstärke, verfügbarer Speicherplatz, Browser-Typ, Namen und Typen von Anwendungen und Dateien sowie Plugins</dd>

  <dt class="warn_section_item">Geräte Operationen</dt>
  <dd class="warn_section_desc">Mausbewegungen, Operationen und Verhaltensweisen, die auf dem Gerät ausgeführt werden</dd>

  <dt class="warn_section_item">Eindeutige Bezeichner</dt>
  <dd class="warn_section_desc">Facebook-interne Geräte und App ID’s</dd>

  <dt class="warn_section_item">Geräte-Signale</dt>
  <dd class="warn_section_desc">Bluetooth-Signale und Informationen über nahegelegene Wi-Fi-Zugangspunkte, Funkturm und Mobilfunkmasten</dd>

  <dt class="warn_section_item">Daten aus Geräteeinstellungen</dt>
  <dd class="warn_section_desc">GPS-Standort, Kamera und Fotos</dd>

  <dt class="warn_section_item">Netzwerk und Verbindungen</dt>
  <dd class="warn_section_desc">Name Ihres Mobilfunkbetreibers oder ISP, Sprache, Zeitzone, Mobiltelefonnummer, IP-Adresse, Verbindungsgeschwindigkeit</dd>

  <dt class="warn_section_item">Cookie-Daten</dt>
  <dd class="warn_section_desc">Gespeicherte Cookies, einschließlich Cookie-IDs und Einstellungen</dd>
</dl>

<h2 class="warn_h2">Informationen, die von Partnern von Facebook eingesammelt werden</h2>

<dl class="warn_section_list">
  <dt class="warn_section_item">Partner, das bedeutet: Werbetreibende, App-Entwickler und Verleger</dt>
  <dt class="warn_section_item">Diese sammeln über Soziale Plug-ins (wie die Schaltfläche "Gefällt mir"), Facebook-Login, Facebook APIs und SDKs oder das Facebook-Pixel die oben genannten Informationen </dt>
</dl>

<h1 class="warn_h1" id="warn_greenFbInsta">Wie benutzt Facebook Ihre personenbezogene Daten?</h1>

<h2 class="warn_h2">Bereitstellung, Personalisierung und Verbesserung der Facebook-Produkte (Facebook-App, Facebook-Messenger, Facebook-Dating etc.)</h2>

<dl class="warn_section_list">
  <dt class="warn_section_item">Facebook-Produkte und -Geräte</dt>
  <dd class="warn_section_desc">Damit Facebook ein Individuelles und einheitliches Erlebnis in allen Facebook-Produkten, auch durch Automatisierung, gewährleisten kann</dd>

  <dt class="warn_section_item">Standortbezogene Informationen</dt>
  <dd class="warn_section_desc">Damit Facebook seine Produkte, einschließlich Werbeanzeigen, bereitstellen kann</dd>

  <dt class="warn_section_item">Produktforschung und -entwicklung</dt>
  <dd class="warn_section_desc">Damit Facebook seine Produkte entwickeln, erproben und verbessern kann</dd>

  <dt class="warn_section_item">Gesichtserkennung</dt>
  <dd class="warn_section_desc">Damit Facebook Sie auf Fotos bzw. in Videos und Kamera Erlebnissen wiedererkennen kann</dd>

  <dt class="warn_section_item">Werbeanzeigen und andere gesponserte Inhalte</dt>
  <dd class="warn_section_desc">Damit Facebook die Werbeanzeigen, Angebote und sonstige gesponserten Inhalte auswählen und personalisieren kann</dd>
</dl>

<h2 class="warn_h2">Bereitstellung von Messungen, Analysen und sonstigen Unternehmens-Services</h2>
<dl class="warn_section_list">
  <dt class="warn_section_item">Facebook nutzt Ihre Aktivitäten außerhalb der Facebook-Produkte, wie z. B. die von Ihnen besuchten Websites und die Werbeanzeigen, zur Optimierung seiner Produkte</dt>
</dl>

<h2 class="warn_h2">Förderung von Schutz, Integrität und Sicherheit</h2>
<dl class="warn_section_list">
  <dt class="warn_section_item">Facebook nutzt Ihre personenbezogene Daten, um damit Facebook Aktivitäten und Konten zu verifizieren, schädliches Verhalten zu bekämpfen, Spam und andere negativen Erlebnisse aufzudecken, die Integrität der Facebook-Produkte zu wahren und den Schutz sowie die Sicherheit zu fördern</dt>
</dl>

<h2 class="warn_h2">Kommunikation zwischen Facebook und Ihnen</h2>
<dl class="warn_section_list">
  <dt class="warn_section_item">Facebook nutzt Ihre personenbezogene Daten, um Ihnen Marketing-Kommunikationen zu senden, mit Ihnen über Facebook-Produkte zu kommunizieren und Sie über die Facebook-Richtlinien und Nutzungsbedingungen zu informieren</dt>
</dl>

<h2 class="warn_h2">Forschung und Innovation für soziale Zwecke</h2>
<dl class="warn_section_list">
  <dt class="warn_section_item">Facebook nutzt Ihre personenbezogene Daten, um Forschung und Innovation durchzuführen und zu unterstützen</dt>
</dl>

<h1 class="warn_h1" id="warn_blueFbInsta">Wie teilt Facebook Ihre personenbezogene Daten?</h1>

<h2 class="warn_h2">Teilen auf Facebook-Produkten</h2>

<dl class="warn_section_list">
  <dt class="warn_section_item">Facebook teilt Personen und Konten, mit denen Sie Inhalte teilen bzw. kommunizieren</dt>
  <dd class="warn_section_desc">Öffentliche Informationen können von jedem auf oder außerhalb der Facebook-Produkte gesehen werden</dd>
  <dd class="warn_section_desc">Dies umfasst auch Ihren Instagram-Benutzernamen</dd>
  <dd class="warn_section_desc">Ihre Inhalte können erneut geteilt oder heruntergeladen werden</dd>

  <dt class="warn_section_item">Facebook teilt Inhalte, die andere über Sie (erneut) teilen</dt>
  <dt class="warn_section_item">Facebook teilt Informationen über Ihren aktiven Status oder Ihre Anwesenheit auf den Facebook-Produkten</dt>

  <dd class="warn_section_desc">Personen in Ihren Netzwerken können Signale sehen, denen sie entnehmen können, ob Sie auf den Facebook-Produkten aktiv sind</dd>

  <dt class="warn_section_item">Facebook teilt Apps, Websites und Integrationen Dritter, die auf den Facebook-Produkten laufen bzw. diese nutzen</dt>
  <dd class="warn_section_desc">Was Sie posten oder teilen, Ihr öffentliches Profil auf Facebook sowie jede Information, die Sie mit Dritten teilen</dd>
  <dd class="warn_section_desc">Die von diesen Diensten Dritter erfassten Informationen unterliegen deren eigenen Nutzungsbedingungen und Richtlinien und nicht der Datenrichtlinie von Facebook</dd>
  <dd class="warn_section_desc">Geräte und Betriebssysteme, die native Versionen von Facebook und Instagram bereitstellen, haben Zugriff auf sämtliche Informationen, die Sie teilen, einschließlich der Informationen, die Ihre Facebook-Freunde mit Ihnen teilen</dd>
  <dt class="warn_section_item">Wenn angehörige Personen unter besonderen Umständen Ihren Facebook-Account erben</dt>
  <dd class="warn_section_desc">Sollten sich Eigentums- oder Machtverhältnisse ändern, werden Informationen von Facebook an den neuen Eigentümer übertragen</dd>
 </dl>

<h2 class="warn_h2">Teilen mit Drittpartnern</h2>
<dl class="warn_section_list">
  <dt class="warn_section_item">Partner, die die Analysedienste von Facebook nutzen</dt>
  <dd class="warn_section_desc">Facebook teilt zusammengefasste Statistiken und Einblicke über Ihre demografischen und interessenbezogenen Informationen </dd>

  <dt class="warn_section_item">Werbetreibende auf Facebook</dt>
  <dd class="warn_section_desc">Facebook teilt die Arten von Personen, die die Werbeanzeigen der Werbetreibenden sehen, den Erfolg dieser Anzeigen und welche Facebook-Werbeanzeigen Sie dazu veranlasst haben, einen Kauf zu tätigen oder eine Handlung durchzuführen</dd>

  <dt class="warn_section_item">Facebook-Partner für Messungen</dt>
  <dd class="warn_section_desc">Facebook stellt seinen Partnern Berichte über Analysen und Messungen bereit</dd>

  <dt class="warn_section_item">Facebook-Partner, die Waren und Dienstleistungen in Facebook-Produkten anbieten</dt>
  <dd class="warn_section_desc">Facebook teilt personenbezogene Daten, die zum Abschluss der Transaktion erforderlich sind, einschließlich Versand- und Kontaktangaben</dd>

  <dt class="warn_section_item">Anbieter und Dienstleister</dt>
  <dd class="warn_section_desc">Facebook stellt Anbietern und Dienstleistern, die Facebook unterstützen, Ihre personenbezogenen Daten und Inhalte bereit</dd>

  <dt class="warn_section_item">Forscher und Wissenschaftler</dt>
  <dd class="warn_section_desc">Facebook stellt Ihre personenbezogenen Daten zur Unterstützung von Forschung und Innovation seines Unternehmens und der Entdeckung und Innovation zu Themen des sozialen Allgemeinwohls bereit</dd>

  <dt class="warn_section_item">Strafverfolgungs- bzw. Vollstreckungsbehörden oder rechtliche Anfragen</dt>
  <dd class="warn_section_desc">Facebook teilt Ihre personenbezogene Informationen unter Umständen mit Strafverfolgungs- bzw. Vollstreckungsbehörden oder als Reaktion auf rechtliche Anfragen</dd>
</dl>

<h2 class="warn_h2" id="warn_darkFbInsta">Wie verarbeitet und übermittelt Facebook Ihre personenbezogene Daten im Rahmen seiner globalen Dienste?</h2>
<dl class="warn_section_list">
  <dt class="warn_section_item">Facebook teilt Ihre personenbezogenen Daten weltweit, sowohl intern zwischen den Facebook-Unternehmen als auch extern mit Facebook-Partnern sowie mit denen, mit denen Sie sich auf der ganzen Welt verbinden und mit denen Sie etwas teilen.
Nach dem Urteil des Europäischen Gerichtshofs vom 16. Juli 2020 (Rs. C-311/18  - „Schrems II“) können Datenübermittlungen in die USA nicht mehr über das US-amerikanische „Privacy Shield“ durchgeführt werden, auf das sich Facebook bisher gestützt hat. Auch die Nutzung von Standardvertragsklauseln ist bei einer Übermittlung in die USA nur bei der Implementierung zusätzlicher Garantien - etwa einer Ende-zu-Ende-Verschlüsselung - möglich. Dies ist bei Facebook derzeit nicht der Fall.
</dt>
</dl>
`;
